import React, { createContext, useContext } from "react"

import { GlobalSearchSelectableOption } from "features/global-search/types/GlobalSearch"

export interface GlobalSearchNavigationContextValue {
  activeIndex: number | null
  listboxId: string
  getItemId: (index: number) => string
  activateItem: (index: number | null) => void
  register: (index: number, ref: HTMLButtonElement) => void
  unregister: (index: number) => void
  updateOption: (index: number, option: GlobalSearchSelectableOption) => void
  onInputKeyDown: React.KeyboardEventHandler<HTMLInputElement>
  onContainerKeyDown: React.KeyboardEventHandler<HTMLDivElement>
  keyboardActiveRef: React.MutableRefObject<boolean>
}

const GlobalSearchNavigationContext = createContext<
  GlobalSearchNavigationContextValue | undefined
>(undefined)

export { GlobalSearchNavigationContext }

export function useGlobalSearchNavigationContext(): GlobalSearchNavigationContextValue {
  const context = useContext(GlobalSearchNavigationContext)
  if (!context) {
    throw new Error(
      "useGlobalSearchNavigationContext must be used within a GlobalSearch"
    )
  }
  return context
}
